export const renderIcon = <IT>(
  iconType: undefined | null | string | ((item: IT) => string | null),
  item: IT
): string | null =>
  typeof iconType === 'function' ? iconType(item) : iconType ?? null;
